export const getInternalFullUrl = (url: string): string => {
  return `${window.location.origin}${url}`;
};
